import { waitForSpacesBetaOptIns } from '@/spaces/use/use-ask-pendo-artifact-add-to-space';
import { waitForListenSignalsBetaOptIns } from '@/voc/use/use-listen-signals-beta';

const BETA_OPT_IN_WAITERS = {
    spaces: waitForSpacesBetaOptIns,
    vocSignals: waitForListenSignalsBetaOptIns,
};

export async function waitForRouteBetaOptIns (route) {
    await BETA_OPT_IN_WAITERS[route.meta.betaId]?.();
}
